module.exports = __webpack_public_path__ + "img/cc3dde3.jpg";